import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-arm-details',
  templateUrl: './arm-details.component.html',
  styleUrls: ['./arm-details.component.css']
})
export class ArmDetailsComponent implements OnInit {

  constructor() { }
  title="Personnel with arms detail";
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/arm-details/arm-details.component.ts